import type { AnalysisStatus } from "./Analysis";

// Разбор больше не изменится сам: готов или упал.
export const isAnalysisFinished = (status: AnalysisStatus): boolean =>
  status === "done" || status === "failed";
